import { action, observable } from 'mobx';

import { Logger, NOOP_LOGGER } from 'bernie-logger';
import { SerializedData, Store } from 'bernie-core';

export class UIPageStore extends Store {
  public static DEFAULTS = {
    displayProgressIndicator: false,
    focusItem: {
      targetKey: null,
      executor: null
    },
    notifications: {
      show: false,
      message: ''
    }
  };

  @observable
  public displayProgressIndicator: boolean;
  @observable
  public notifications: any;
  @observable
  public notificationTimeout: any;

  @observable
  public focusItem: {
    targetKey: string;
    executor: (executorTargetKey: string, callback: () => void) => void;
  };

  constructor(state: SerializedData = {}, logger: Logger = NOOP_LOGGER) {
    super(state, logger);
  }

  public hydrate(data: SerializedData): void {
    Object.assign(this, data);
  }

  @action
  public showProgressIndicator(minDisplayTime: number): void {
    this.displayProgressIndicator = true;

    if (minDisplayTime) {
      setTimeout(() => {
        this.hideProgressIndicator();
      }, minDisplayTime);
    }
  }

  @action
  public setFocusItem(targetKey: string) {
    let claimed = false;

    const executor = (executorTargetKey: string, callback: () => void) => {
      if (!claimed && executorTargetKey === targetKey && typeof callback === 'function') {
        claimed = true;

        if (typeof callback === 'function') {
          callback();
        }
      }
    };

    this.focusItem.targetKey = targetKey;
    this.focusItem.executor = executor;
  }

  @action
  public hideProgressIndicator(): void {
    this.displayProgressIndicator = false;
  }

  @action
  public showNotification(message): void {
    this.notifications.show = true;
    this.notifications.message = message;

    // clears any existing notifications
    if (this.notificationTimeout) {
      clearTimeout(this.notificationTimeout);
    }

    this.notificationTimeout = setTimeout(() => {
      this.resetNotification();
    }, 3000);
  }

  @action
  public resetNotification(): void {
    this.notifications.show = false;
    this.notifications.message = '';
    if (this.notificationTimeout) {
      clearTimeout(this.notificationTimeout);
    }
  }
}
